import { SVGInterface } from "../../interface";

const ErrorFilled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7142 12.0001C22.7142 6.08272 17.9173 1.28577 11.9999 1.28577C6.08529 1.29226 1.29214 6.08541 1.28564 12.0001C1.28564 17.9174 6.08259 22.7143 11.9999 22.7143C17.9173 22.7143 22.7142 17.9174 22.7142 12.0001ZM10.9285 6.64296H13.0714L13.0714 13.0715H10.9285V6.64296ZM10.9285 17.3572L10.9285 15.2144H13.0714V17.3572H10.9285Z"
      fill={color || "#1C2B36"}
    />
  </svg>
);

export default ErrorFilled;
